import React, { useMemo } from 'react';

import { Typography, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { getAlertToneStyles } from './UnderwritingAlertsCell.styles';
import { getKeyedAlerts } from './UnderwritingAlertsCell.utils';

const UnderwritingAlertsCell = ({ underwritingAlerts = [] }) => {
  const theme = useTheme();
  const toneStyles = useMemo(() => getAlertToneStyles(theme), [theme]);
  const keyedAlerts = useMemo(() => getKeyedAlerts(underwritingAlerts), [underwritingAlerts]);

  return keyedAlerts.map(({ alertType, comment, key }) => (
    <Typography key={key} sx={toneStyles[alertType.toLowerCase()]} variant="regular14">
      {comment}
    </Typography>
  ));
};

UnderwritingAlertsCell.propTypes = {
  underwritingAlerts: PropTypes.array,
};

export default UnderwritingAlertsCell;
